import IranFlag from "../../assets/images/iran.webp";
import React, {useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import {useParams} from "react-router-dom";
import api from "../../api";
import DeleteIcon from "@material-ui/icons/Delete";
import {toast, ToastContainer} from "react-toastify";
import AttachmentIcon from "../../assets/images/attachment.png";
import AddIcon from "@mui/icons-material/Add";
import VectorImage from "../../assets/images/vector-image.png";
import LoadingSpinner from "../Loading";
import {e2p} from "../../utils/utils";

function Photo() {
    const [car, setCar] = useState(null);
    const [smoothingFullCost, setSmoothingFullCost] = useState(0);
    const [paintingFullCost, setPaintingFullCost] = useState(0);
    const [smoothingFullDuration, setSmoothingFullDuration] = useState(0);
    const [paintingFullDuration, setPaintingFullDuration] = useState(0);
    const [album, setAlbum] = useState(null);
    const [file, setFile] = useState(null);
    const [isHovering, setIsHovering] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const {carId} = useParams();
    const {requestId} = useParams();

    const handleFileSelect = (e) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const handleImageUpload = async () => {
        const fileInput = document.getElementById('image-input');
        const file = fileInput.files[0];
        if (!file) {
            return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('url', file);
        formData.append('type', 1);
        formData.append('content_type', 2);
        formData.append('repair_request_id', requestId);
        try {
            await api.post('/album', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    window.location.reload();
                });
        } catch (error) {
            console.log(error)
            // toast.error(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        async function fetchSmoothingItems() {
            const response = await api.get(`/repair-item/smoothing/${requestId}`);
            setSmoothingFullCost(response.data.fullCost)
            setSmoothingFullDuration(response.data.totalDuration)
        }

        fetchSmoothingItems();

        async function fetchPaintingItems() {
            const response = await api.get(`/repair-item/painting/${requestId}`);
            setPaintingFullCost(response.data.fullCost)
            setPaintingFullDuration(response.data.totalDuration)
        }

        fetchPaintingItems();

        async function fetchCar() {
            const response = await api.get(`/car/${carId}`);
            setCar(response.data.data);
        }

        fetchCar();

        const fetchAlbum = async () => {
            try {
                api.get(`/repair-request/${requestId}`)
                    .then(res => {
                        const report = res.data.data;
                        const album = report.albums[0];
                        setAlbum(album)
                    })
            } catch (error) {
                toast.error(error.response.data.message);
            }
        };
        fetchAlbum();

    }, []);

    const handleDeleteClick = (albumId) => {
        api.delete(`/album/${albumId}`)
            .then(response => {
                window.location.reload();
            })
            .catch(error => {
                toast.error(error.response.data.message);
            });
    };

    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        
                        {car &&
                            <div className="row d-block justify-content-center g-0">
                                <div className="row mx-auto pelak g-0 mb-3 mt-3" style={{width: '20rem'}}>
                                    <div className="col">
                                        <div className="row my-auto">
                                            <div className="col border-start border-end-0">
                                                <p className="text-center fw-bold iranNo">ایران</p>
                                                <div>
                                                    <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                                </div>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto leftSide">
                                        <div className="flag">
                                            <img src={IranFlag} alt="iran's flag"/>
                                        </div>
                                        <div className="iranText text-center">
                                            <p>I.R.</p>
                                            <p>IRAN</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {car &&
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                    <div className="card rounded-4 border-3 border-dark mb-4">
                                        <h5 className="card-header bg-dark text-white text-center">افزودن عکس</h5>
                                        <div className="card-body">
                                            {!album &&
                                                <div>
                                                    <label htmlFor="image-input"
                                                           className="card btn justify-content-center shadow"
                                                           style={{height: '8rem'}}>
                                                        <div className="d-flex justify-content-center">
                                                            <img src={AttachmentIcon} alt="attachment"
                                                                 style={{height: '25px', width: '25px'}}/>
                                                            <div className="me-2 my-auto">انتخاب تصویر موردنظر</div>
                                                        </div>
                                                    </label>
                                                    <input type="file" id="image-input" className='form-control'
                                                           onChange={handleFileSelect} style={{visibility: "hidden"}}/>
                                                    <div className='mt-2'>{file && `${file.name} - ${file.type}`}
                                                        <button onClick={handleImageUpload}
                                                                className='btn btn-success w-100'>
                                                            <AddIcon/>اضافه کردن
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                            {album &&
                                                <div
                                                    className="col"
                                                    onMouseEnter={() => setIsHovering(true)}
                                                    onMouseLeave={() => setIsHovering(false)}
                                                    style={{position: "relative"}}
                                                >
                                                    {album ? (
                                                        <img
                                                            src={album.url}
                                                            alt=""
                                                            className=""
                                                            style={{width: "100%", height: "100%", objectFit: "cover"}}
                                                        />
                                                    ) : (
                                                        <img
                                                            src={VectorImage}
                                                            alt=""
                                                            className=""
                                                            style={{width: "100%", height: "100%", objectFit: "cover"}}
                                                        />
                                                    )}
                                                    {isHovering && album && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "50%",
                                                                left: "50%",
                                                                transform: "translate(-50%, -50%)",
                                                                cursor: "pointer",
                                                                background: "rgba(0, 0, 0, 0.5)",
                                                                borderRadius: "50%",
                                                                padding: "10px",
                                                            }}
                                                            onClick={() => handleDeleteClick(album.id)}
                                                        >
                                                            <DeleteIcon style={{color: "white"}}/>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                        <tr className="text-center">
                                            <th>نوع تعمیر</th>
                                            <th>زمان (روز)</th>
                                            <th>مبلغ (تومان)</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td className="text-center">صافکاری</td>
                                            <td className="text-center">{e2p(smoothingFullDuration.toString())}</td>
                                            <td className="text-center">{e2p(smoothingFullCost?.toLocaleString()) ?? ''}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">نقاشی</td>
                                            <td className="text-center">{e2p(paintingFullDuration.toString())}</td>
                                            <td className="text-center">{e2p(paintingFullCost?.toLocaleString()) ?? ' '}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div className="row justify-content-center">
                                        <div className="col-6 d-grid gap-2">
                                            <input
                                                type="submit"
                                                className="btn btn-info"
                                                name="submit"
                                                value="تعیین وضعیت درخواست"
                                                onClick={() => {
                                                    window.location.href = `/car/${carId}/status/${requestId}`
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default Photo
